import React, { useEffect, useState } from "react";
import HoldBets from "../betTicker/HoldBets";
import OpenBets from "../betTicker/OpenBets";

function GameTypes(props) {
  //const user = useContext(UserContext);

  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [color, setColor] = useState("#00FFFF");

  const handleChangeColor = (event) => {
    setColor(event.target.value);
  };

  useEffect(() => {
    console.log("props", props);
  }, []);

  return (
    <React.Fragment>
      <HoldBets color={color} message={props.message} />
      <OpenBets />
    </React.Fragment>
  );
}

export default GameTypes;
